module.exports = __webpack_public_path__ + "img/cashback.cec97551.png";